import { render, staticRenderFns } from "./Qurban.vue?vue&type=template&id=1b2c12fa"
import script from "./Qurban.vue?vue&type=script&lang=js"
export * from "./Qurban.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports